import React, { memo, useState } from 'react'

import * as S from '../style'
import { RequiredBadge } from './RequiredBadge'

type PropsInput = {
  id: number
  label: string
  value: string
  requiredFlag: boolean
  onChange: (value: string) => void
  // 数値欄（荷量）は IME 変換対象外。半角数字への即時ストリップを維持するため、
  // ローカルバッファせず onChange をそのまま親へ流す（バッファは text 欄のみ）
  numeric?: boolean
  isSp?: boolean
  'data-dg-id'?: string
}

const ImportExportInputRow: React.FC<PropsInput> = ({
  id,
  label,
  value,
  onChange,
  requiredFlag,
  numeric = false,
  isSp,
  'data-dg-id': dataDgId,
}) => {
  // text 欄は入力中はローカル state を真実にし、store 反映は onBlur に移す（store 直結だと
  // 入力ごとの同期再レンダリングで value が書き戻され IME 変換が1文字ごと確定される）。
  // prevValue は外部からの store 変化をレンダー中に同期するための前回値保持。
  const [prevValue, setPrevValue] = useState(value)
  const [localValue, setLocalValue] = useState(value)
  if (value !== prevValue) {
    setPrevValue(value)
    setLocalValue(value)
  }

  // numeric 欄は毎キー親へ通知して即ストリップ（IME 非対象なのでバッファ不要）。
  // text 欄はローカルバッファし onBlur で確定する。
  const inputProps = numeric
    ? {
        value,
        onChange: (e: React.ChangeEvent<HTMLInputElement>) => onChange(e.target.value),
      }
    : {
        value: localValue,
        onChange: (e: React.ChangeEvent<HTMLInputElement>) => setLocalValue(e.target.value),
        onBlur: () => {
          if (localValue !== value) {
            onChange(localValue)
          }
        },
      }

  const input = (
    <S.InputImportExport
      data-dg-id={`${isSp ? 'sp-' : ''}entry-load-page-input-${id}`}
      type="text"
      className="w-100"
      {...inputProps}
    />
  )

  // SP: ラベルを上・インプットを下に縦積み。必須はオレンジバッジ
  if (isSp) {
    return (
      <div className="mb-3" data-dg-id={`sp-${dataDgId}`}>
        <div className="mb-2" data-dg-id={`sp-entry-load-page-label-${id}`}>
          {requiredFlag && <RequiredBadge dataDgId={`sp-entry-load-page-required-${id}`} />}
          {label}
        </div>
        <div data-dg-id={`sp-entry-load-page-input-wrapper-${id}`}>{input}</div>
      </div>
    )
  }

  return (
    <S.SelectInputWrapper data-dg-id={dataDgId}>
      <S.RequiredText data-dg-id={`entry-load-page-required-${id}`}>
        {requiredFlag && '必須'}
      </S.RequiredText>
      <div style={{ width: 145 }} className="label" data-dg-id={`entry-load-page-label-${id}`}>
        {label}
      </div>
      <div style={{ width: 255 }} data-dg-id={`entry-load-page-input-wrapper-${id}`}>
        {input}
      </div>
    </S.SelectInputWrapper>
  )
}

export default memo(ImportExportInputRow)
